import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    GET_INITIAL_DATA_CONCIERGE_SUCCESS
} from '../../Screens/Concierge/actions/concierge';

/**
 * Estado inicial.
 */
const initialState = {
    programSelected: false,
    perfiles: 0,
    defaultProducto: null
};

/**
 * Reduce store.
 */
let result;

function concierge(state = initialState, action) {
    switch (action.type) {

        case GET_INITIAL_DATA_CONCIERGE_SUCCESS:

            let menuUsuario = action.result.GET_MENU_BY_USUARIO_ID;
            let path = action.result.GET_USUARIO_INICIO[0] ? true : false;
            let productosCount = action.result.GET_PRODUCTO_USUARIO_LOGIN.length;

            let initialProduct = action.result.GET_PRODUCTO_USUARIO_LOGIN[0].ProductoId;
            let rowsPerProduct = action.result.GET_PRODUCTO_USUARIO_LOGIN.filter(
                x => x.ProductoId != initialProduct
            );   

            return {
                ...state,
                programSelected: path,
                productos: productosCount,
                defaultProducto: rowsPerProduct.length == 0 ? action.result.GET_PRODUCTO_USUARIO_LOGIN[0] : null,
            };
            break;

        default:
            result = {
                ...state
            };
            break;
    }

    return result;
}

export default concierge;